<template src="./Orizon.html">
  
</template>

<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      orizon: null
    }
  },
  mounted() {
    const vm = this;
    vm.getCards();
  },
  methods: {
    download() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/orizon/" +
            vm.orizon.id +
            "/download/" + vm.orizon.name,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
            responseType: 'blob'
          }
        )
        .then(function(response) {
          if(response.status === 200){
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", vm.orizon.name + ".txt");
            document.body.appendChild(link);
            link.click();
          }
        });
    },
    getCards() {
      const vm = this;
      vm.$vs.loading();
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/orizon",
          {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.orizon = response.data;
            vm.$vs.loading.close();
          }
        })
        .catch(function() {
          vm.$vs.loading.close();
        });
    },
  },
}
</script>

<style lang="scss" scr="./Orizon.scss">
</style>